<template>
  <div class="admin-page">
    <app-header></app-header>
    <app-nav></app-nav>
    <div>
      <slot></slot>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
  export default {
    name: 'admin'
  }
</script>

<style scoped lang="scss">
.admin-page {
  min-width: 700px;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/Admin.vue